import React from 'react'
import { useNavigate } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'
import {
  fetchLinkInfo,
  prepareSimSearch,
} from '@disco/state-management/reducers/search-page'

import { DiscoCallout } from 'components/ds'

import { useDispatch } from 'hooks/use-redux'

type Props = {
  url: string
}

const SimSearchNewPageBanner = ({ url }: Props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    mixpanel.sendPureEvent('Click link', {
      Context: 'Similarity Search',
      Type: 'New search page push',
      Location: 'Explorer',
    })
    dispatch(prepareSimSearch(url))
    dispatch(fetchLinkInfo(url))
    navigate('/search')
  }

  return (
    <DiscoCallout
      type="feature"
      dismissible
      dismissKey="sim-search-new-page-banner"
      variant="soft"
      size="1"
      highContrast={false}
    >
      Did you know Sim Search results can be filtered by metadata in our{' '}
      <a href="/search" onClick={handleClick}>
        new search
      </a>
      ?
    </DiscoCallout>
  )
}

export default SimSearchNewPageBanner
